import { constants } from "@newsela/angelou";

const { circular } = constants.legacy_typography.family;
const greyExtraLight = constants.colors.ui.neutral[25];

export const footerCss = {
  width: "100%",
  textDecoration: "none",
  display: "flex",
  flexFlow: "row wrap",
  borderTop: "1px solid " + greyExtraLight,
  justifyContent: "center",
  fontFamily: circular,
  minHeight: "80px",
  backgroundColor: greyExtraLight,
  lineHeight: "2rem",
};

export const listCss = {
  flexWrap: "wrap",
  display: "flex",
  listStyleType: "none",
  padding: "0px",
  justifyContent: "center",
};

export const atagCss = {
  color: "inherit",
  ":hover": {
    textDecoration: "underline",
    cursor: "pointer",
  },
  ":focus": {
    textDecoration: "underline",
  },
};

export const itemCss = {
  marginRight: "2rem",
  paddingBottom: "20px",
};
